import { getRequest, postRequest } from "../../../services/RestServices";
import * as scheduleUrls from "../../api/scheduler/url";

export const getShippingAddress = async (bundleIds, accountId) => {
  try {
    const response = await getRequest(scheduleUrls.GET_SHIPPING_ADDRESS + `${accountId}` + `?bundles=${bundleIds}`);
    return response;
  } catch (err) {
    return err;
  }
};

export const getVehicleDetails = async (payload) => {
  try {
    const response = await postRequest(scheduleUrls.GET_VEHICLE_LIST, payload);
    return response;
  } catch (err) {
    return err;
  }
};

export const postApplyActions = async (payload) => {
  try {
    const response = await postRequest(scheduleUrls.POST_APPLY_ACTIONS, payload);
    return response;
  } catch (err) {
    return err;
  }
};

export const getVehicleDetailInformation = async (bundleIds, crmRefId, vehicleId) => {
  try {
    const response = await getRequest(
      scheduleUrls.GET_VEHICLE_DETAILS_INFORMATION + `?bundleIds=${bundleIds}&crmRefId=${crmRefId}&vehicleId=${vehicleId}`
    );
    return response;
  } catch (err) {
    return err;
  }
};
